<div *ngIf="slide==0" class="flex flex-row-reverse pt-3">
  <button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-text"
    (click)="onClose()"></button>
</div>
<div class="new-project-wrapper">
  <div [@animSlider]="slide" class="w-full h-full flex flex-row">

    <ng-container *ngIf="slide==0">
      <div class="flex-grow-1 new-project-container">
        <div class="new-project-header flex align-items-center gap-3 mb-6">
          <img src="/assets/images/new-project-2.png" style="height:auto; width:100px;">
          <h3>{{'DESC.PROJECT_CREATE_TITLE' | translate}}</h3>
        </div>

        <app-basic-project-form (action)="onAction($event)"></app-basic-project-form>

      </div>
    </ng-container>

    <ng-container *ngIf="slide==1">
      <div class="w-full flex success-message justify-content-center">
        <div style="width: 500px;" class="flex flex-column align-items-center gap-3">
          <img src="/assets/images/new-project-2.png" style="height:auto; width: 70%">
          <h3 class="text-center">{{'LABEL.PROJECT_CREATED_SUCCESS' | translate}}</h3>
          <button pButton pRipple [label]="'BUTTON.CLOSE' | translate" class="p-button-primary w-10"
            (click)="onClose(true)"></button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="slide==2">
      <div class="w-full flex justify-content-center">
        <div style="width: 500px;" class="flex flex-column align-content-center justify-content-center gap-3">
          <img src="/assets/images/save-planet.png" style="height:auto; width: 100%">
          <h3 class="text-pink-600 text-center">{{'ERROR.PROJECT_CREATE' | translate}}</h3>
          <button pButton pRipple [label]="'BUTTON.CLOSE' | translate" class="p-button-danger"
            (click)="onClose(false)"></button>
        </div>
      </div>
    </ng-container>

  </div>
</div>
